import React, { useEffect, useState } from 'react';
import { useExpenses } from '../../Pages/Expenses/ExpensesStore';
import { Button, Form, Input, Modal, Table } from 'antd';

function Expenses(props) {
    let [open, setOpen] = useState(false);
    let { expenses, columns, getExpenses, addExpenses } = useExpenses();
    useEffect(() => {
        getExpenses();
    }, []);
    return (
        <>
        <Modal title="Qo'shish" open={open} onCancel={() => {setOpen(false)}} footer={null} width={1000}>
            <Form layout="vertical" onFinish={(v)=>{
                addExpenses(v)
            }}>
                <Form.Item name="summa" label="Summa">
                    <Input />
                </Form.Item>
                <Form.Item name="description" label="Izoh">
                    <Input.TextArea rows={4} />
                </Form.Item>
                <Form.Item>
                    <Button htmlType="submit" type="primary">Qo'shish</Button>
                </Form.Item>
            </Form>
        </Modal>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                <h3>Xarajatlar</h3>
                <Button type="primary" onClick={() => {setOpen(true)}}>Qo'shish</Button>
            </div>
            <Table
                pageTitle='Xarajatlar'
                dataSource={expenses}
                columns={columns}
            />
        </>
    );
}

export default Expenses;